/* eslint-disable no-console */
import { Configuration, LogLevel } from '@azure/msal-browser';
import { Config } from '@dispatch/web/config';

/**
 * User Flows from NGS SSO, environment specific
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
export const b2cPolicies = {
  names: {
    forgotPassword: Config.B2C?.policies?.names.forgotPassword,
    localSignUp: Config.B2C?.policies?.names.localSignUp,
  },
  authorities: {
    forgotPassword: {
      authority: Config.B2C?.policies?.authorities.forgotPassword.authority,
    },
    localSignUp: {
      authority: Config.B2C?.policies?.authorities.localSignUp.authority,
    },
  },
  authorityDomain: Config.B2C?.policies?.authorityDomain,
};

const b2cAppRegistration = {
  clientId: Config.B2C?.appRegistration?.clientId,
};

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: b2cAppRegistration.clientId, // This is the ONLY mandatory field that you need to supply.
    authority: b2cPolicies.authorities.forgotPassword.authority, // Use forgot password as default authority (will be overridden during login)
    knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
    redirectUri: window.location.origin + '/auth-redirect', // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
    postLogoutRedirectUri: '/sign-in', // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: 'localStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

// env variables are comma deliminated string 'scope1, scope2, ...'
const appScopes = (Config.B2C?.scopes || '').split(', ');

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: appScopes,

  extraQueryParameters: { domain_hint: 'nextgearsolutions.com' },
};
